import { ButtonBase } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import React, { useState } from 'react';

export interface SimpleDialogProps {
  open: boolean;
  photo: string;
  onClose: () => void;
}

function PhotoDialog(props: SimpleDialogProps) {
  const { onClose, photo, open } = props;

  function handleClose() {
    onClose();
  }

  return (
    <Dialog onClose={handleClose} open={open}>
      <img src={photo} width="100%" alt="" />
    </Dialog>
  );
}

type Props = {
  photo: string;
};

export default function ActionPhoto({ photo }: Props) {
  const [open, setOpen] = useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <ButtonBase focusRipple onClick={handleClickOpen}>
        <img src={photo} width="80px" alt="" />
      </ButtonBase>
      <PhotoDialog photo={photo} open={open} onClose={handleClose} />
    </div>
  );
}
